import { render } from "./TabConfigSkills.vue?vue&type=template&id=563fb002"
import script from "./TabConfigSkills.vue?vue&type=script&lang=js"
export * from "./TabConfigSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__